import styled from 'styled-components';

export const Content = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  width: -webkit-fill-available;
  max-height: 13rem;

  h1 {
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 2rem;
  }

  p {
    color: ${({ theme }) => theme.colors.gray_300};
    font-weight: 400;
    font-size: 1rem;
  }

  .historic-scroll {
    max-height: 25rem;
    overflow-y: auto;

    .historicItemContainer {
      h2 {
        color: ${({ theme }) => theme.colors.secondary};
      }

      .historicItemContent {
        display: flex;
        flex-direction: column;
        padding: 1rem;

        .containerAttachments {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          align-items: center;
          padding: 0.5rem;
        }

        .historicItemAttachment {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          width: 100%;
        }

        .containerNote {
          display: flex;
          align-items: flex-start;
          gap: 0.5rem;

          svg {
            width: 3rem;
            height: 3rem;
            padding: 0.5rem 0;
            color: ${({ theme }) => theme.colors.secondary};
            fill: ${({ theme }) => theme.colors.secondary};
          }

          .contentNote {
            display: flex;
            flex-direction: column;

            .noteDescription {
              font-weight: 400;
              font-size: 1.2rem;
            }

            p {
              font-weight: 300;
            }
          }
        }
      }
    }
  }

  @media (max-width: 650px) {
    padding: 0;
  }
`;
